import type { ReactElement } from 'react';

import { ProtectedRoute } from './protected-route';
import type { Fallback, Required } from './protected-route.type';

export default function protect(
  component: ReactElement,
  required: Required,
  fallback?: Fallback,
) {
  return (
    <ProtectedRoute required={required} fallback={fallback}>
      {component}
    </ProtectedRoute>
  );
}
